/**
 * actions
 */
const SET_LOGIN_ACCOUNT = 'SET_LOGIN_ACCOUNT';
const SET_STAMP_SUBMITTER = 'SET_STAMP_SUBMITTER';
const SET_ENTRIES = 'SET_ENTRIES';
const SET_PRICE_TABLE = 'SET_PRICE_TABLE';

/**
 * reducers
 */
const initialState = {
  loginAccount: null,
  stampSubmitter: null,
  isDoneStampSubmitterFirstFetch: false,
  entries: null,
  priceTable: null,
};

export const reducers = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOGIN_ACCOUNT:
    case SET_STAMP_SUBMITTER:
    case SET_ENTRIES:
    case SET_PRICE_TABLE:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

/**
 * action creaters
 */
export function setLoginAccount(loginAccount) {
  return {
    type: SET_LOGIN_ACCOUNT,
    payload: { loginAccount },
  };
}

export function setStampSubmitter(stampSubmitter) {
  return {
    type: SET_STAMP_SUBMITTER,
    payload: { stampSubmitter, isDoneStampSubmitterFirstFetch: true },
  };
}

export function setEntries(entries) {
  return {
    type: SET_ENTRIES,
    payload: { entries },
  };
}

export function setPriceTable(priceTable) {
  return {
    type: SET_PRICE_TABLE,
    payload: { priceTable },
  };
}